// Written in this round about way for babel-transform-imports
import withRouter from "react-router/es/withRouter";

export default withRouter;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-router-dom/es/withRouter.js
// module id = 443
// module chunks = 4 5 6 7